import React, { useContext } from "react";
import styled                from "styled-components";
import { OrderContext }      from "~/contexts/OrderContext";

const OrderTermsContainer = styled.div`
  padding-top: 2rem;
  padding-bottom: 2rem;
  textarea {
    width: 100%;
    min-height: 200px;
    padding: 8px;
    font-size: 12px;
  }
  p {
    display: none;
  }

  @media print {
    textarea {
      display: none;
    }
    p {
      display: block;
      font-size:12px;

    }
  }
`;

export const OrderTerms = () => {
  const { order, dispatch } = useContext(OrderContext);

  const onChange = ({ currentTarget: { value } }) => {
    dispatch({
      type: "TERMS_UPDATED",
      payload: value,
    });
  };

  return (
    <OrderTermsContainer>
      <div className="mb-4">Terms</div>
      <textarea onChange={onChange} value={order?.attributes?.terms} />
      <p
        dangerouslySetInnerHTML={{
          __html: order?.attributes?.terms?.replace(/\n/g, "<br>"),
        }}
      />
    </OrderTermsContainer>
  );
};
